(function () {
  function rootUrl() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function focusableElements(element) {
    return Array.prototype.slice.call(element.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (item) {
      return !item.hidden && item.getAttribute('aria-hidden') !== 'true';
    });
  }

  function updateBodyLock() {
    /* Header drawers/search never lock <body>; locking changes the iframe viewport
       width in Shopify preview and causes the underlying page to jump. */
    var hasOpenOverlay = document.querySelector(
      '.collection-filter-drawer.is-open, .quick-add-dialog[open]'
    );
    document.body.classList.toggle('drawer-open', Boolean(hasOpenOverlay));
  }

  
  function preventHeaderOverlayBackgroundScroll(event) {
    var overlay = document.querySelector(
      '#MobileDrawer.is-open, #CartDrawer.is-open, #SearchDrawer.is-open'
    );
    if (!overlay) return;
    var panel = event.target.closest && event.target.closest('.drawer__panel, .search-drawer__panel');
    if (!panel) event.preventDefault();
  }

  document.addEventListener('wheel', preventHeaderOverlayBackgroundScroll, { passive: false });
  document.addEventListener('touchmove', preventHeaderOverlayBackgroundScroll, { passive: false });

  function setMobileDrawer(open) {
    var drawer = document.getElementById('MobileDrawer');
    if (!drawer) return;

    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');

    var trigger = document.querySelector('[data-drawer-open="#MobileDrawer"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.blur();
    }
  }

  function syncTrigger(element, open) {
    if (!element || !element.id) return;
    document.querySelectorAll('[aria-controls="' + element.id + '"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setDrawer(element, open, trigger) {
    if (!element) return;
    var isPassiveDrawer = element.id === 'CartDrawer' || element.id === 'MobileDrawer';

    if (open && !isPassiveDrawer) element._returnFocus = trigger || document.activeElement;

    element.classList.toggle('is-open', open);
    element.setAttribute('aria-hidden', open ? 'false' : 'true');
    syncTrigger(element, open);
    updateBodyLock();

    /* Menu + Cart: do not move focus on open/close.
       In Shopify preview focus handoff can visibly jump the page. */
    if (isPassiveDrawer) return;

    if (open) {
      window.setTimeout(function () {
        var preferred = element.querySelector('[data-search-input]') || element.querySelector('.drawer__close, button, a, input, select');
        if (preferred) {
          try { preferred.focus({ preventScroll: true }); }
          catch (error) { preferred.focus(); }
        }
      }, 20);
    } else if (element._returnFocus && typeof element._returnFocus.focus === 'function') {
      try { element._returnFocus.focus({ preventScroll: true }); }
      catch (error) { element._returnFocus.focus(); }
      element._returnFocus = null;
    }
  }

  function setCollectionFilter(element, open, trigger) {
    if (!element) return;
    if (open) element._returnFocus = trigger || document.activeElement;
    element.classList.toggle('is-open', open);
    element.setAttribute('aria-hidden', open ? 'false' : 'true');
    syncTrigger(element, open);
    updateBodyLock();
    if (open) {
      window.setTimeout(function () {
        var focusable = element.querySelector('.drawer__close, button, input');
        if (focusable) focusable.focus();
      }, 20);
    } else if (element._returnFocus && typeof element._returnFocus.focus === 'function') {
      element._returnFocus.focus();
      element._returnFocus = null;
    }
  }

  function updateBadge(itemCount) {
    var action = document.querySelector('[data-cart-action]');
    if (!action) return;
    var badge = action.querySelector('[data-cart-count]');
    if (!badge && itemCount > 0) {
      badge = document.createElement('span');
      badge.className = 'header__cart-count';
      badge.setAttribute('data-cart-count', '');
      action.appendChild(badge);
    }
    if (badge) {
      badge.textContent = itemCount > 0 ? itemCount : '';
      badge.hidden = itemCount < 1;
    }
  }

  function refreshCart() {
    return Promise.all([
      fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart state request failed');
        return response.json();
      }),
      fetch(rootUrl() + '?sections=cart-drawer', { headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Cart section request failed');
        return response.json();
      })
    ]).then(function (results) {
      updateBadge(results[0].item_count);
      var html = results[1]['cart-drawer'];
      var current = document.querySelector('#CartDrawer');
      if (html && current) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html.trim();
        var replacement = wrapper.querySelector('#CartDrawer') || wrapper.firstElementChild;
        if (replacement) current.replaceWith(replacement);
      }
    });
  }

  function submitCartChange(form, submitter) {
    var body = new FormData(form);
    if (submitter && submitter.name) body.set(submitter.name, submitter.value);
    form.setAttribute('aria-busy', 'true');
    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart change request failed');
      return response.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      setDrawer(document.querySelector('#CartDrawer'), true);
    }).catch(function () {
      form.removeAttribute('aria-busy');
      form.submit();
    });
  }

  function currentVariantState(productRoot) {
    var selector = productRoot.querySelector('[data-variant-select]');
    var option = selector && selector.options ? selector.options[selector.selectedIndex] : null;
    return {
      id: option ? option.value : productRoot.getAttribute('data-current-variant-id'),
      price: option ? option.getAttribute('data-price') : productRoot.getAttribute('data-current-price'),
      compare: option ? option.getAttribute('data-compare-price') : productRoot.getAttribute('data-current-compare-price'),
      available: option ? option.getAttribute('data-available') === 'true' : productRoot.getAttribute('data-current-available') === 'true',
      mediaId: option ? option.getAttribute('data-media-id') : productRoot.getAttribute('data-current-media-id')
    };
  }

  function syncProductVariant(productRoot, updateUrl) {
    if (!productRoot) return;
    var state = currentVariantState(productRoot);
    var mainButton = productRoot.querySelector('[data-main-atc]');
    var stickyButton = productRoot.querySelector('[data-sticky-atc-trigger]');
    var addLabel = productRoot.getAttribute('data-add-label') || 'Add to selection';
    var unavailableLabel = productRoot.getAttribute('data-unavailable-label') || 'Currently unavailable';

    productRoot.setAttribute('data-current-variant-id', state.id || '');
    productRoot.setAttribute('data-current-price', state.price || '');
    productRoot.setAttribute('data-current-compare-price', state.compare || '');
    productRoot.setAttribute('data-current-available', state.available ? 'true' : 'false');
    productRoot.setAttribute('data-current-media-id', state.mediaId || '');
    productRoot.querySelectorAll('[data-product-price]').forEach(function (price) {
      if (state.price) price.textContent = state.price;
      price.classList.toggle('price__sale', Boolean(state.compare && state.compare !== state.price));
    });
    productRoot.querySelectorAll('[data-product-compare-price]').forEach(function (compare) {
      compare.textContent = state.compare || '';
      compare.hidden = !state.compare || state.compare === state.price;
    });

    [mainButton, stickyButton].forEach(function (button) {
      if (!button) return;
      button.disabled = !state.available;
      button.setAttribute('aria-disabled', state.available ? 'false' : 'true');
      var label = button.querySelector('[data-atc-label]');
      if (label) label.textContent = state.available ? addLabel : unavailableLabel;
    });

    if (state.mediaId) {
      var media = productRoot.querySelector('[data-product-media-id="' + state.mediaId + '"]');
      if (media && media.parentElement) media.parentElement.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
    }

    if (updateUrl && state.id && window.history && window.history.replaceState) {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', state.id);
      window.history.replaceState({}, '', nextUrl.toString());
    }
  }

  function initProduct(productRoot) {
    if (!productRoot || productRoot.getAttribute('data-product-initialized') === 'true') return;
    productRoot.setAttribute('data-product-initialized', 'true');
    syncProductVariant(productRoot, false);
    var mainButton = productRoot.querySelector('[data-main-atc]');
    var sticky = productRoot.querySelector('[data-product-sticky-atc]');
    if (!mainButton || !sticky || !('IntersectionObserver' in window)) return;
    productRoot._stickyAtcObserver = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      sticky.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0.15 });
    productRoot._stickyAtcObserver.observe(mainButton);
  }

  function loadRecommendations(container) {
    if (!container || container.getAttribute('data-loaded') === 'true') return;
    var url = container.getAttribute('data-url');
    var content = container.querySelector('[data-recommendations-content]');
    if (!url || (content && !content.hidden)) return;
    container.setAttribute('data-loaded', 'true');
    fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Recommendations request failed');
      return response.text();
    }).then(function (htmlText) {
      var parsed = new DOMParser().parseFromString(htmlText, 'text/html');
      var replacement = parsed.querySelector('[data-product-recommendations="' + container.getAttribute('data-product-recommendations') + '"] [data-recommendations-content]');
      if (replacement && replacement.innerHTML.trim() && content) {
        content.innerHTML = replacement.innerHTML;
        content.hidden = false;
      }
    }).catch(function () {
      container.hidden = true;
    });
  }

  function initRecommendations(container) {
    if (!container || container.getAttribute('data-recommendations-initialized') === 'true') return;
    container.setAttribute('data-recommendations-initialized', 'true');
    if (!container.getAttribute('data-url')) return;
    if (!('IntersectionObserver' in window)) {
      loadRecommendations(container);
      return;
    }
    container._recommendationsObserver = new IntersectionObserver(function (entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadRecommendations(container);
    }, { rootMargin: '0px 0px 200px 0px' });
    container._recommendationsObserver.observe(container);
  }

  function initDynamicSections(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-product-root]').forEach(initProduct);
    root.querySelectorAll('[data-product-recommendations]').forEach(initRecommendations);
  }

  function openCartFromReturnState() {
    var shouldOpen = false;
    var url = new URL(window.location.href);

    try {
      shouldOpen = sessionStorage.getItem('veyrissaOpenCart') === '1';
      if (shouldOpen) sessionStorage.removeItem('veyrissaOpenCart');
    } catch (error) {}

    if (url.searchParams.get('open_cart') === '1') {
      shouldOpen = true;
      url.searchParams.delete('open_cart');
      if (window.history && window.history.replaceState) {
        var query = url.searchParams.toString();
        window.history.replaceState({}, '', url.pathname + (query ? '?' + query : '') + url.hash);
      }
    }

    if (!shouldOpen) {
      document.documentElement.classList.remove('veyrissa-cart-return-pending');
      return;
    }

    var drawer = document.querySelector('#CartDrawer');
    if (drawer) setDrawer(drawer, true);

    window.requestAnimationFrame(function () {
      document.documentElement.classList.remove('veyrissa-cart-return-pending');
    });
  }

  initDynamicSections(document);
  openCartFromReturnState();

  document.addEventListener('shopify:section:load', function (event) {
    initDynamicSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-product-root], [data-product-recommendations]').forEach(function (element) {
      if (element._stickyAtcObserver) element._stickyAtcObserver.disconnect();
      if (element._recommendationsObserver) element._recommendationsObserver.disconnect();
    });
  });

  function handleSameHomepageLink(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return false;

    try {
      var current = new URL(window.location.href);
      var target = new URL(link.href, window.location.origin);
      var rootPath = rootUrl();
      if (!rootPath.endsWith('/')) rootPath += '/';

      var currentPath = current.pathname.endsWith('/') ? current.pathname : current.pathname + '/';
      var targetPath = target.pathname.endsWith('/') ? target.pathname : target.pathname + '/';

      if (
        target.origin === current.origin &&
        currentPath === rootPath &&
        targetPath === rootPath &&
        !target.hash
      ) {
        event.preventDefault();
        event.stopPropagation();

        var mobileDrawer = link.closest('#MobileDrawer');
        if (mobileDrawer) setMobileDrawer(false);

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        return true;
      }
    } catch (error) {}

    return false;
  }

  document.addEventListener('click', function (event) {
    if (handleSameHomepageLink(event)) return;

    var mobileDrawerOpener = event.target.closest('[data-drawer-open="#MobileDrawer"]');
    if (mobileDrawerOpener) {
      event.preventDefault();
      event.stopPropagation();
      setMobileDrawer(true);
      return;
    }

    var mobileDrawerCloser = event.target.closest('#MobileDrawer [data-drawer-close]');
    if (mobileDrawerCloser) {
      event.preventDefault();
      event.stopPropagation();
      setMobileDrawer(false);
      return;
    }

    var stickyAtc = event.target.closest('[data-sticky-atc-trigger]');
    if (stickyAtc) {
      event.preventDefault();
      var stickyProduct = stickyAtc.closest('[data-product-root]');
      var stickyForm = stickyProduct && stickyProduct.querySelector('[data-product-form]');
      var mainAtc = stickyProduct && stickyProduct.querySelector('[data-main-atc]');
      if (stickyForm && mainAtc && !mainAtc.disabled) {
        if (stickyForm.requestSubmit) stickyForm.requestSubmit(mainAtc);
        else mainAtc.click();
      }
      return;
    }

    var mediaControl = event.target.closest('[data-product-media-target]');
    if (mediaControl) {
      event.preventDefault();
      var mediaProduct = mediaControl.closest('[data-product-root]');
      var media = mediaProduct && mediaProduct.querySelector('[data-product-media-id="' + mediaControl.getAttribute('data-product-media-target') + '"]');
      if (media && media.parentElement) media.parentElement.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
      return;
    }

    var drawerOpener = event.target.closest('[data-drawer-open], [data-search-open]');
    if (drawerOpener) {
      event.preventDefault();
      var selector = drawerOpener.getAttribute('data-drawer-open') || drawerOpener.getAttribute('data-search-open');
      setDrawer(document.querySelector(selector), true, drawerOpener);
      return;
    }

    var quickAddOpener = event.target.closest('[data-quick-add-open]');
    if (quickAddOpener) {
      var dialog = document.querySelector(quickAddOpener.getAttribute('data-quick-add-open'));
      if (dialog && dialog.showModal) {
        event.preventDefault();
        dialog._returnFocus = quickAddOpener;
        dialog.showModal();
        updateBodyLock();
      }
      return;
    }

    var filterOpener = event.target.closest('[data-collection-filter-open]');
    if (filterOpener) {
      event.preventDefault();
      setCollectionFilter(document.querySelector('#CollectionFilterDrawer'), true, filterOpener);
      return;
    }

    var filterCloser = event.target.closest('[data-collection-filter-close]');
    if (filterCloser) {
      event.preventDefault();
      setCollectionFilter(filterCloser.closest('.collection-filter-drawer'), false);
      return;
    }

    var drawerCloser = event.target.closest('[data-drawer-close], [data-search-close]');
    if (drawerCloser) {
      event.preventDefault();
      setDrawer(drawerCloser.closest('.drawer, .search-drawer'), false);
      return;
    }

    var dialogCloser = event.target.closest('[data-dialog-close]');
    if (dialogCloser) {
      event.preventDefault();
      var parentDialog = dialogCloser.closest('dialog');
      if (parentDialog) {
        parentDialog.close();
        if (parentDialog._returnFocus) parentDialog._returnFocus.focus();
      }
      updateBodyLock();
      return;
    }

    var localizationCloser = event.target.closest('[data-localization-close]');
    if (localizationCloser) {
      event.preventDefault();
      var localizationDisclosure = localizationCloser.closest('[data-localization-disclosure]');
      if (localizationDisclosure) localizationDisclosure.open = false;
    }
  });

  document.addEventListener('cancel', function (event) {
    if (event.target.matches('.quick-add-dialog')) {
      if (event.target._returnFocus) event.target._returnFocus.focus();
      updateBodyLock();
    }
  });

  document.addEventListener('keydown', function (event) {
    var activeOverlay = document.querySelector('.drawer.is-open, .search-drawer.is-open, .collection-filter-drawer.is-open, .quick-add-dialog[open]');
    if (event.key === 'Tab' && activeOverlay) {
      var items = focusableElements(activeOverlay);
      if (items.length) {
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
    if (event.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open, .search-drawer.is-open').forEach(function (element) {
        setDrawer(element, false);
      });
      document.querySelectorAll('.collection-filter-drawer.is-open').forEach(function (element) {
        setCollectionFilter(element, false);
      });
      document.querySelectorAll('.quick-add-dialog[open]').forEach(function (dialog) {
        dialog.close();
        if (dialog._returnFocus) dialog._returnFocus.focus();
      });
      document.querySelectorAll('[data-localization-disclosure][open]').forEach(function (details) {
        details.open = false;
      });
      updateBodyLock();
    }
  });

  document.addEventListener('change', function (event) {
    var variantSelector = event.target.closest('[data-variant-select]');
    if (variantSelector) syncProductVariant(variantSelector.closest('[data-product-root]'), true);
  });

  document.addEventListener('submit', function (event) {
    var cartChangeForm = event.target.closest('[data-cart-change-form]');
    if (cartChangeForm) {
      event.preventDefault();
      submitCartChange(cartChangeForm, event.submitter);
      return;
    }

    var form = event.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    event.preventDefault();
    form.setAttribute('aria-busy', 'true');
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      var dialog = form.closest('dialog');
      if (dialog) dialog.close();
      updateBodyLock();
      setDrawer(document.querySelector('#CartDrawer'), true);
    }).catch(function () {
      form.removeAttribute('aria-busy');
      form.submit();
    });
  });
})();
